export default "__VITE_ASSET__DsHnwKC4__"